/**
 * Authentication Routes (Frontend)
 * Centralized route definitions for Vue Router navigation
 *
 * Note: For API endpoints, use API_ENDPOINTS from './endpoints.ts'
 */
export const AUTH_ROUTES = {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    DASHBOARD: '/dashboard',
} as const;

/**
 * Authentication Error Messages
 * User-facing error strings for auth operations
 */
export const AUTH_ERRORS = {
    LOGIN_FAILED: 'Invalid email or password. Please try again.',
    NETWORK_ERROR: 'Unable to connect. Please check your internet connection.',
    GOOGLE_AUTH_FAILED: 'Google authentication failed. Please try again.',
    SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    PASSWORD_TOO_SHORT: 'Password must be at least 8 characters.',
    FIELD_REQUIRED: 'This field is required.',
    SERVER_ERROR: 'Something went wrong. Please try again later.',
} as const;

/**
 * Validation Rules
 * Authentication validation constants
 */
export const AUTH_VALIDATION = {
    MIN_PASSWORD_LENGTH: 8,
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
} as const;
